/*
* <license header>
*/

import React from 'react'
import { Flex, Heading, Text, View } from '@adobe/react-spectrum'
import GraphBarVertical from '@spectrum-icons/workflow/GraphBarVertical'
import { APP_TYPES, APP_TEMPLATES, APPS } from '../../data/constants'

const STATS = [
  { value: APP_TYPES.length, label: 'App Types', color: '#ff9800' },
  { value: APP_TEMPLATES.length, label: 'Templates', color: '#00bcd4' },
  { value: APPS.length, label: 'Applications', color: '#2196f3' },
  { value: 2, label: 'Supported LLMs', color: '#4caf50' },
  { value: 4, label: 'RAG Sources', color: '#673ab7' }
]

const STAT_STYLE = {
  textAlign: 'center'
}

export const PlatformStatistics = () => (
  <View marginBottom="size-600">
    <Flex alignItems="center" gap="size-150" marginBottom="size-400">
      <View
        UNSAFE_style={{
          width: '2rem',
          height: '2rem',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #8b7cb8 0%, #673ab7 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <GraphBarVertical size="S" UNSAFE_style={{ color: 'white' }} />
      </View>
      <Heading level={2} UNSAFE_style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700 }}>
        Platform Statistics
      </Heading>
    </Flex>
    <div className="PlatformStats-grid">
      {STATS.map(({ value, suffix = '', descriptor, label, color }, i) => (
        <View key={i} UNSAFE_style={STAT_STYLE}>
          <Flex direction="column" alignItems="center" gap="size-50">
            <Flex alignItems="baseline" gap="size-50" justifyContent="center">
              <Text UNSAFE_style={{ fontSize: '1.75rem', fontWeight: 700, color }}>
                {value}
              </Text>
              {suffix && (
                <Text UNSAFE_style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--gray-600)' }}>
                  {suffix}
                </Text>
              )}
              {descriptor && (
                <Text UNSAFE_style={{ fontSize: '0.75rem', color: 'var(--gray-600)' }}>
                  {descriptor}
                </Text>
              )}
            </Flex>
            <Text UNSAFE_style={{ fontSize: '0.875rem', color: 'var(--gray-600)' }}>
              {label}
            </Text>
          </Flex>
        </View>
      ))}
    </div>
  </View>
)
